// Sprint ONBOARD ONB.C1 (A.3) — dashboard flash banner for the /setup gate.
//
// When the server-enforced /setup gate (GET /setup-project → 403
// SETUP_GATE_FORBIDDEN) bounces an ineligible user, SetupWizardPage redirects
// to /dashboard?notice=setup_forbidden. This banner reads that flag, shows a
// dismissible notice, and clears the param after ~4s so a refresh doesn't keep
// re-showing it — mirroring the ?github=connected flash idiom in
// GitHubConnectionCard.tsx (there is no global toast system).

import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function SetupGateNotice() {
  const [searchParams, setSearchParams] = useSearchParams();
  const show = searchParams.get('notice') === 'setup_forbidden';

  useEffect(() => {
    if (!show) return;
    const id = setTimeout(() => {
      const next = new URLSearchParams(searchParams);
      next.delete('notice');
      setSearchParams(next, { replace: true });
    }, 4000);
    return () => clearTimeout(id);
  }, [show, searchParams, setSearchParams]);

  if (!show) return null;

  return (
    <div
      data-testid="setup-gate-notice"
      role="status"
      style={{
        margin: '0 0 16px', padding: '10px 14px',
        background: 'rgba(245, 158, 11, 0.10)', border: '1px solid rgba(245, 158, 11, 0.3)',
        borderRadius: 'var(--radius-sm, 8px)', fontFamily: 'var(--font-body)', fontSize: 13,
        color: 'var(--text)',
      }}
    >
      This setup wizard is for the assigned Technical Lead. Contact your Buyer if you need access.
    </div>
  );
}
